<template>
  <div>
    <PageHeader title="Buy Entry"></PageHeader>
    <v-container>
      <v-row>
        <v-col>
          <div class="honeyBold">
            <p>Your are buying <b>{{ticketCount}}</b> {{ticketCount === 1 ? "ticket" : "tickets"}} for <b>£{{totalCost}}</b></p>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-alert
            border="right"
            color="teal darken-1"
            dark
          >
            Trust Payments Javascript Library Integration will be here. Use the buttons below to simulate either a successful or failed payment through Trust Payments.
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <form method="POST" ref="tpForm" action="https://payments.securetrading.net/process/payments/choice">
            <input type="hidden" name="sitereference" value="test_fanhivelimited101670">
            <input type="hidden" name="stprofile" value="default">
            <input type="hidden" name="stdefaultprofile" value="st_iframe_cardonly">
            <input type="hidden" name="ruleidentifier" value="STR-6">
            <input type="hidden" name="successfulurlredirect" value="https://eoz6bl864ve2rrj.m.pipedream.net">
            <input type="hidden" name="ruleidentifier" value="STR-7">
            <input type="hidden" name="declinedurlredirect" value="https://eoz6bl864ve2rrj.m.pipedream.net">
            <input type="hidden" name="currencyiso3a" value="GBP">
            <input type="hidden" name="mainamount" value="5.00">
            <input type="hidden" name="version" value="2">
            <input type="hidden" name="stextraurlredirectfields" value="wallettransactionid">
            <input type="hidden" ref="customone" name="wallettransactionid">
          </form>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            outlined
            block
            large
            color="success"
            @click="approvePayment"
            style="color: #ffffff !important;border: 1px solid #ffb300;"
          >
            <v-icon
              left
              dark
              color="green"
            >
              mdi-check
            </v-icon>
            Simulate Payment Approved
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            outlined
            block
            large
            color="error"
            @click="declinePayment"
            style="color: #ffffff !important;border: 1px solid #ffb300;"
          >
            <v-icon
              left
              dark
              color="error"
            >
              mdi-close
            </v-icon>
            Simulate Payment Declined
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-overlay
      :absolute="false"
      :value="overlay"
      :opacity="0.9"
      >
      <v-progress-circular
        indeterminate
        color="amber"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';
import Socket from "../../plugins/socket";

export default {
  name: 'paymentstub',
  components: {
    PageHeader
  },
  data: () => ({
    overlay: false,
    ticketCount: null,
    totalCost: null,
    competitionId: null,
    walletTransactionId: null
  }),
  computed: {
    wallet () {
      return this.$store.getters.wallet;
    },
    updatingWalletCredits () {
      return this.$store.getters.updatingWalletCredits;
    }
  },
  methods: {
    reconnect: function () {
      var scope = this;
      console.log('Connectionid is null when approving payment, must get new one.');
      Socket.connect(scope.$store.getters.userSub.userName);
      setTimeout(() => {
        scope.approvePayment();
      }, 2500);
    },
    approvePayment () {
      var scope = this;
      scope.overlay = true;

      if(scope.$store.getters.connectionId === null){
        scope.reconnect();
        return;
      }

      scope.$store.commit('setUpdatingWalletCredits', 1);

      this.$store.dispatch('addWalletTransaction', {
        walletId: scope.wallet.id,
        isDebit: false,
        amount: parseInt(scope.$route.query.totalCost),
        notes: 'Buy entry'
      }).then(addWalletTransactionResponse => {
          scope.walletTransactionId = addWalletTransactionResponse.id;
          console.log(`New wallet transaction added [${addWalletTransactionResponse.id}]`);
        }, error => {
            console.log(error);
        });
    },
    declinePayment() {
      this.$router.push({name: 'payment-result', query: {result: 'declined'}});
    },
    updateWallet(){
      var scope = this;
      this.$store.dispatch('getWallet', this.$store.getters.userSub.id).then(response => {
          scope.$localStorage.set('wallet', JSON.stringify(response));
          scope.$store.commit('setWallet', response);
          scope.$store.commit('setUpdatingWalletCredits', 0);
          scope.overlay = false;
          //scope.$router.push({name: 'active-competitions', query: { competitionId: scope.competitionId}});

          scope.$refs.customone.value = scope.walletTransactionId;
          scope.$refs.tpForm.submit();

        }, error => {
            console.log(error);
        })
    }
  },
  created () {
    this.ticketCount = parseInt(this.$route.query.ticketCount);
    this.totalCost = parseInt(this.$route.query.totalCost);
    this.competitionId = this.$route.query.competitionId;
  },
  // mounted() {
  //   let tpExternal = document.createElement('script');
  //   tpExternal.setAttribute('src', 'https://cdn.eu.trustpayments.com/js/latest/st.js');
  //   document.head.appendChild(tpExternal);

  //   let tpInternal = document.createElement('script');
  //   tpInternal.setAttribute('src', '/trust-payments.js');
  //   document.head.appendChild(tpInternal);
  // },
  watch: {
      updatingWalletCredits (newVal) {
        if(newVal === 2) {
          this.updateWallet();
        }
      }
    }
}
</script>